/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgEdit16(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      fill='none'
      viewBox='0 0 16 16'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M10.907 4.973l1.258 1.114M10.907 4.973L9.676 3.885'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M2.716 13.681a.252.252 0 00.294.267l2.78-.482 8.625-9.407L11.494 1.5l-8.586 9.37-.192 2.811z'
      />
    </svg>
  );
}

export default SvgEdit16;
